const React = require('react');
const withState = require('../../../../../../utils/withState');
const {ThirdLayerMenu} = require('../../../AdminLayout');
const {paramStore} = require('../../../../../../stores');

const config$ = paramStore('config', 'trxProcessing');

module.exports = withState(() => {
  return ({currentConfigTab}, {userId, links, views}) => {

    const View = views[currentConfigTab] ? views[currentConfigTab] : views[links[0].id];

    return (
      <>
        <ThirdLayerMenu
          emitter={config$}
          links={links}
        />
        <View userId={userId} emitter={config$} />
      </>
    );
  }
}, {
  currentConfigTab: config$
})
